import { ISO_CODE_GERMANY } from '@constants/countries';

/**
 * @description Returns if the current website is german
 * @example <caption>Example usage of isGermany</caption>
 * isGermany()
 * @return {*}  {boolean}
 */
const isGermany = (): boolean =>
    window.__ENVIRONMENT_DETAILS__.languageIsoCode === ISO_CODE_GERMANY;

export { isGermany };
